// Firebase configuration and initialization
import { initializeApp } from "firebase/app";
import { getAnalytics, Analytics } from "firebase/analytics";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBNp3vkmlS4wsXNFiJbHldyL1QeVK2BTNA",
  authDomain: "mirolumo.firebaseapp.com",
  projectId: "mirolumo",
  storageBucket: "mirolumo.firebasestorage.app",
  messagingSenderId: "486447093333",
  appId: "1:486447093333:web:53466bf15ba909506ba6dc",
  measurementId: "G-LDY1LGB6YR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics (only in browser environment)
let analytics: Analytics | null = null;

if (typeof window !== 'undefined') {
  try {
    analytics = getAnalytics(app);
    console.log('📊 Google Analytics initialized successfully');
  } catch (error) {
    console.error('Failed to initialize Google Analytics:', error);
    // Explicitly set to null if initialization fails
    analytics = null;
  }
}

export { app, analytics };
